<div class="flex justify-between">
  <div>
    <h3 class="mat-subtitle-1">Two-way SMS integration with Podium</h3>
    <p>
      Principle synchronises Podium's Inbox with Principle's Conversations to
      ensure that you have full context when communicating with your patients.
    </p>
    <a href="https://www.podium.com.au/" target="_blank"
      >Learn more about Podium</a
    >
  </div>
  <img class="logo" src="/assets/integrations/podium-logo.png" />
</div>

<div *ngIf="enabled$ | async; else disabled" class="flex flex-col gap-4">
  <div class="flex flex-col gap-4">
    <div *ngIf="podiumLocations$ | async as podiumLocations">
      <ng-container *ngIf="podiumLocations.length">
        <h3 class="mat-subtitle-1">Add Practice Location</h3>
        <pr-podium-location-input
          #practiceLocationInput
          [locations]="podiumLocations"
        >
          <button
            mat-icon-button
            matTooltip="Add new practice location"
            [disabled]="
              practiceLocationInput.form
                | map: addPracticeLocationDisabled$
                | async
            "
            (click)="addPracticeLocation(practiceLocationInput.form)"
          >
            <mat-icon>add</mat-icon>
          </button>
        </pr-podium-location-input>
      </ng-container>
    </div>

    <div>
      <h3 class="mat-subtitle-1">Practice Locations</h3>
      <ng-container *ngIf="mappedLocations$ | async as mappedLocations">
        <ng-container *ngIf="mappedLocations.length; else noMappedLocations">
          <div
            *ngFor="
              let mappedLocation of mappedLocations$ | async;
              trackBy: trackByIndex
            "
            class="flex items-center"
          >
            <div class="flex-1">{{ mappedLocation.practice.name }}</div>
            <div class="flex-1">{{ mappedLocation.locationUid }}</div>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Delete practice location"
              (click)="deletePracticeLocation(mappedLocation)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </ng-container>

        <ng-template #noMappedLocations>
          <small class="mat-caption">No practice locations registered</small>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <div class="flex flex-col gap-2">
    <h3 class="mat-subtitle-1">Integration Authorisation</h3>
    <small
      >If the integration with Podium needs to be updated, you can reauthorise
      Principle against your Podium account via the button below. This can be in
      cases where Principle has new functionality that requires extra
      permissions from Podium.</small
    >
    <a
      mat-stroked-button
      color="primary"
      target="_blank"
      [href]="integrationLink$ | async"
      >Reauthorise With Podium</a
    >
  </div>

  <div class="flex flex-col gap-2">
    <h3 class="mat-subtitle-1">Danger Zone</h3>
    <small
      >Removing the Podium integration without setting up another SMS provider
      will mean that SMS messages will no longer be sent/received.</small
    >
    <button mat-stroked-button color="warn" (click)="removeIntegration()">
      Remove Podium Integration
    </button>
  </div>
</div>

<ng-template #disabled>
  <a
    mat-flat-button
    color="primary"
    target="_blank"
    [href]="integrationLink$ | async"
    >Add to Podium</a
  >
</ng-template>
